import React,{useRef } from "react";
import CanvasDraw from "react-canvas-draw";


const Drawing = (props,ref) => { 
    
    
    //const image = document.getElementById('source');
    
    return <>
        <CanvasDraw
            ref={ref}
            {...props}
            
        />

    </>
}
// Drawing.defaultProps = {
//     handlerEraseAll: () => void 0
// }
export default React.forwardRef(Drawing);;